import graphql from 'graphql-tag'
import { PromiseOrValue } from 'graphql/jsutils/PromiseOrValue'

export const resetGqlNodeData = <T>(
  arr: Array<{ data: T }>,
  key = 'data',
  filtersFn?: any
): Array<T> => {
  const data: Array<T> =
    arr && arr.length > 0
      ? arr.map(item => {
          return filtersFn ? filtersFn(item[key]) : item[key]
        })
      : []

  return data
}

export const queryDataDictionary = async (ddcodes, gqlClient) => {
  //
  const query = ddcodes
    .map(ddCode => {
      return `
      ${ddCode}: queryDataDictionaryListLang(input: { ddCode: "${ddCode}"} ) {
        value: ddValue
        label: ddText
        remark:ddRemark
      }`
    })
    .join(',')
  const gql = graphql`query queryDataDictionaryListLang{${query}}`
  const { data } = await gqlClient.query(gql)

  Object.keys(data).forEach(item => {
    let statusMap = {}
    data[item].length > 0 &&
      data[item].forEach(({ value, label }) => {
        statusMap[value] = label
        // value有可能是以逗号连接的多个值的组合
        if (typeof value == 'string' && value.indexOf(',') > -1) {
          value.split(',').forEach(key => (statusMap[key] = label))
        } else {
          statusMap[value] = label
        }
      })
    data[item + '_MAP'] = statusMap
  })
  return data
}

// 将数据转为map
export const expandArrayToMap = (
  list,
  { labelKey = 'label', valueKey = 'value' } = {}
) => {
  const result = {}
  list.forEach(item => {
    const value = item[valueKey]
    const label = item[labelKey]

    // value有可能是以逗号连接的多个值的组合
    if (typeof value == 'string' && value.indexOf(',') > -1) {
      value.split(',').forEach(key => (result[key] = label))
    } else {
      result[value] = label
    }
  })

  return result
}

/**
 * 判断类型工厂
 */
interface TypeClassType {
  isFunction(s): s is FunctionConstructor
  isPromise(s): s is Promise<any>
  isObject(s): s is Record<string, any>
  isArray(s): s is any[]
  isString(s): s is string
  isBoolean(s): s is boolean
  isUndefined(s): s is undefined
  isNull(s): s is null
  isNumber(s): s is number
}
export const TypeClass: TypeClassType = (() => {
  const checkTypeArr = [
    'Function',
    'Promise',
    'Array',
    'Object',
    'String',
    'Number',
    'Undefined',
    'Null',
    'Boolean'
  ]
  const res = Object.create(null)
  for (const type of checkTypeArr) {
    res[`is${type}`] = (target: any) =>
      Object.prototype.toString.call(target).slice(8, -1) === type
  }
  return res
})()
export const isFunction = TypeClass.isFunction
export const isPromise = TypeClass.isPromise
export const isArray = TypeClass.isArray
export const isObject = TypeClass.isObject
export const isString = TypeClass.isString
export const isNumber = TypeClass.isNumber
export const isUndefined = TypeClass.isUndefined
export const isNull = TypeClass.isNull
export const isBoolean = TypeClass.isBoolean
export const isImage = url => {
  const reg = /^(\s|\S)+.+(jpg|png|JPG|PNG|gif|GIF|jpeg|JPEG)+$/
  return reg.test(url)
}
export const isVideo = url => {
  const reg = /^(\s|\S)+.+(mp4|MP4|ogg|OGG|webm|WEBM)+$/
  return reg.test(url)
}
